import { styled } from '@linaria/react';
import { css } from '@linaria/core';

import { Button, COLORS, Pill, Select } from '@livecommerce/design-system';

import { PORTRAIT, LANDSCAPE, INITIAL_POSITION, DRAGGABLE_SIZES } from './constants.js';

export const isDraggingStyle = css`
  cursor: grabbing;
`;

export const draggableStyle = css`
  position: fixed;
  z-index: 9;
  bottom: ${INITIAL_POSITION.bottom}px;
  right: ${INITIAL_POSITION.right}px;
  box-shadow: 0 0 10px rgba(0,0,0,0.3);
  cursor: grab;
`;

export const draggablePortraitSize = css`
  width: ${DRAGGABLE_SIZES[PORTRAIT].width}px;
  height: ${DRAGGABLE_SIZES[PORTRAIT].height}px;
`;

export const draggableLandscapeSize = css`
  width: ${DRAGGABLE_SIZES[LANDSCAPE].width}px;
  height: ${DRAGGABLE_SIZES[LANDSCAPE].height}px;
`;

export const inlineStyle = css`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const Broadcaster = styled.div`
  background-color: ${COLORS.dark_700};
  border-radius: 8px;
  transition: width 0.3s ease-in-out, height 0.3s ease-in-out;
  video {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
`;

export const TopControls = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
  width: 100%;
  display: flex;
  padding: 8px;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 16px;
`;

export const isLive = css`
  justify-content: space-between;
`;

export const LivePill = styled(Pill)`
  margin: 4px;
  padding: 2px 6px;
  line-height: 16px;
  &:before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: ${COLORS.white};
    margin-right: 4px;
    vertical-align: middle;
  }
`;

export const Controls = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  gap: 16px 64px;
  border-radius: 0px 0px 8px 8px;
  background: linear-gradient(180deg, rgba(41, 41, 41, 0) 0%, rgba(41, 41, 41, 0.00441937) 7.55%, rgba(41, 41, 41, 0.0159704) 14.08%, rgba(41, 41, 41, 0.0344) 19.79%, rgba(41, 41, 41, 0.0594553) 24.89%, rgba(41, 41, 41, 0.0908832) 29.59%, rgba(41, 41, 41, 0.128431) 34.09%, rgba(41, 41, 41, 0.171845) 38.61%, rgba(41, 41, 41, 0.220873) 43.34%, rgba(41, 41, 41, 0.275262) 48.5%, rgba(41, 41, 41, 0.334758) 54.29%, rgba(41, 41, 41, 0.399109) 60.93%, rgba(41, 41, 41, 0.468062) 68.61%, rgba(41, 41, 41, 0.541363) 77.54%, rgba(41, 41, 41, 0.61876) 87.94%, rgba(41, 41, 41, 0.7) 100%);
`;

export const InputControls = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const InputButton = styled(Button)`
  border-radius: 50%;
  max-width: 32px;
  max-width: 32px;
  min-height: 32px;
  max-height: 32px;
  width: 32px;
  height: 32px;
  padding: 0px;
  background: rgba(41, 41, 41, 0.6);
  border: none;
`;

export const AspectRatioButton = styled(InputButton)`
  svg {
    transition: transform 0.3s ease-in-out;
  }
`;

export const landscapeRotation = css`
  svg {
    transform: rotate(90deg);
  }
`;

export const SourceSelections = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: column;
  flex-flow: wrap;
  width: 100%;
}`;

export const SourceSelect = styled(Select)`
  flex: 1;
  width: 100%;
  min-width: 175px;
  & div:first-child {
    margin: 0;
  }
  button {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background-color: rgba(41, 41, 41, 0.6);
  }
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-flex;
  z-index: 1;
  color: ${COLORS.light_200};

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const WideButton = styled(Button)`
  flex: 1;
  min-width: 152px;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s;
`;
